import { lazy } from "react";

const Home = lazy(() => import("@views/Home"))
const NewsDetail = lazy(() => import("@views/Home/New/NewsDetail"))

const HomeRoutes = [
    {
        path: '/home',
        element: <Home />
    },
    {
        path: '/news/:newsid',
        element: <NewsDetail />
    },
]

export default HomeRoutes
